import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'
import validation from '@/mixins/validation'
import mixins from '@/mixins'
import moment from 'moment'
import { DEFAULT_FILTERS } from '@/modules/reviews/constants'

export default {
  name: 'filter-reviews',
  mixin: [mixins, validation],
  data () {
    return {
      dateRangeText: '',
      menuFrom: false,
      menuTo: false,
      search: '',
      searchInput: '',
      filter: DEFAULT_FILTERS
    }
  },
  computed: {
    ...mapGetters({
      setting: 'courses/setting',
      filters: 'reviews/filters',
      currentCourse: 'reviews/currentCourse',
      isLoadingCourse: 'reviews/isLoadingCourse',

      basicUsers: 'user/basicUsers',
      basicUsersLoading: 'user/basicUsersLoading',
      homeWorks: 'reviews/homeWorks',
      materials: 'reviews/materials',
      graduateWork: 'reviews/graduateWork',
      lessons: 'reviews/lessons',
      filterCourseId: 'reviews/filterCourseId'
    }),
    materialTypes () {
      return ['lesson', 'graduate_work', 'home_work']
    },
    typesHomeWork () {
      return [
        {
          name: 'Testing',
          id: 1
        },
        {
          name: 'Detailed response',
          id: 2
        }
      ]
    },
    getLocalStorageFilter () {
      return JSON.parse(localStorage.getItem('reviews_filters'))
    },
    getLocalStorageSearch () {
      return JSON.parse(localStorage.getItem('reviews_search'))
    },
    getLocalStorageFilterCourseId () {
      return localStorage.getItem('reviews_filter_course_id')
    }
  },
  created () {
    this.setFilter()
    this.getLocalStorageDataFilter()
    this.fetchCourse(this.$route.params)
    this.fetchCourseMaterials()
    this.fetchGraduateWork(this.$route.params)
  },
  methods: {
    ...mapActions({
      fetchList: 'reviews/GET_LIST',
      fetchUsersBasic: 'user/GET_BASIC_USERS',
      fetchCourse: 'reviews/GET_COURSE_MODULES',
      fetchCourseMaterials: 'reviews/GET_COURSE_MATERIALS',
      fetchGraduateWork: 'reviews/GET_COURSE_GRADUATE_WORK',
      fetchLessons: 'reviews/GET_COURSE_LESSONS'
    }),
    ...mapMutations({
      changeFilter: 'reviews/CHANGE_FILTER',
      setFilterCourseId: 'reviews/setFilterCourseId',
      setFilterData: 'reviews/setFilterData'
    }),
    sendRequest: debounce(function () {
      this.fetchList(this.filter)
    }, 500),
    setFilter () {
      const courseId = +this.$route.params.courseId
      if (!!this.filterCourseId && this.filterCourseId === courseId) {
        Object.assign(this.filter, this.filters)
        // this.autoCompleteChanged({
        //   full_name: this.filters.user
        // })
      }
    },
    formattedDate (date) {
      if (!date) return ''
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    // users
    changeInputUsers: debounce(function (val) {
      if (!val) return
      if (this.search?.full_name !== val) {
        this.fetchUsersBasic({
          keywords: val
        })
      }
    }, 500),
    changeFilterLocal (val, type) {
      this.setFilterCourseId(+this.$route.params.courseId)
      if (typeof val === 'undefined') val = ''
      this.changeFilter({
        value: val,
        type: type
      })
      if (type === 'module') {
        this.changeFilter({
          value: null,
          type: 'material'
        })
        this.changeFilter({
          value: null,
          type: 'materialType'
        })
      }
      if (type === 'graduateWork') {
        this.changeFilter({
          value: null,
          type: 'module'
        })
        if (val !== '') {
          this.changeFilter({
            value: 'graduate_work',
            type: 'materialType'
          })
        } else {
          this.changeFilter({
            value: null,
            type: 'materialType'
          })
        }

        this.changeFilter({
          value: val,
          type: 'material'
        })
      }
      this.fetchCourseMaterials()
      if (type === 'material' && this.materials && val !== '') {
        const material = this.materials.find(m => +m.id === +val)
        const mv = material ? material.material : ''
        this.changeFilter({
          value: mv,
          type: 'materialType'
        })
      }
      localStorage.setItem('reviews_filters', JSON.stringify(this.filters))
      localStorage.setItem('reviews_filter_course_id',
        +this.$route.params.courseId)
      this.fetchList(this.$route.params)
      this.$emit('change')
    },
    autoCompleteChanged (e, type) {
      if (!e) {
        this.filter.user = ''
        this.search = ''
      } else {
        this.filter.user = e.id
        this.search = e
      }
      this.changeFilter({
        value: e.hasOwnProperty('id') ? e.id : '',
        type: type
      })
      this.fetchList(this.$route.params)
      localStorage.setItem('reviews_filters', JSON.stringify(this.filters))
      localStorage.setItem('reviews_filter_course_id',
        +this.$route.params.courseId)
    },
    filterUsersAutoComplete (item, queryText) {
      return item.full_name.toLocaleLowerCase()
        .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.email.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1 ||
        item.id.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    },
    handleResetFilter () {
      this.changeFilter(null)
      for (const i in this.filter) {
        this.filter[i] = ''
      }
      this.filters.isChecking = '1'
      this.search = ''
      this.$refs.datetimeFrom.clearHandler()
      this.$refs.datetimeTo.clearHandler()
    },
    getLocalStorageDataFilter () {
      const courseId = +this.$route.params.courseId
      this.setFilterCourseId(+this.getLocalStorageFilterCourseId)
      if (!!this.filterCourseId && this.filterCourseId === courseId) {
        this.setFilterData(this.getLocalStorageFilter)
        Object.assign(this.filter, this.filters)
        // this.autoCompleteChanged({
        //   full_name: this.filters.user
        // })
      } else {
        localStorage.removeItem('reviews_filters')
        localStorage.removeItem('reviews_filter_course_id')
      }
    }
  }
  // destroyed () {
  //   const courseId = +this.$route.params.courseId
  //   if (!!this.filterCourseId && this.filterCourseId !== courseId) this.changeFilter()
  // }
}
